import { createI18n } from 'vue-i18n'
import ru from './locales/ru.json'
import en from './locales/en.json'

const savedLocale = localStorage.getItem('locale')
const initialLocale: 'ru' | 'en' = savedLocale === 'en' ? 'en' : 'ru'

type MessageSchema = typeof ru

type LocaleMessages = {
  ru: MessageSchema
  en: MessageSchema
}

export const i18n = createI18n<[MessageSchema], 'ru' | 'en'>({
  locale: initialLocale,
  fallbackLocale: 'ru',
  legacy: false,
  messages: { ru, en } as LocaleMessages,
})
